import React from 'react'
import styled from 'styled-components'

const Mission = () => {
  return (
    <Wrapper>
      <h1>Wir bauen ein Haus in Frankreich mit Maisons de la Côte Atlantique (MCA)</h1>
      Wir leben in Deutschland. Hier steht wie es läuft.
      <p class="faint">
        Wir teilen unsere Erfahrungen mit dem Hausbau, geben Tipps für die Kreditsuche in Frankreich und die Grundstückssuche. Wir berichten von Hindernissen, Fallstricken und was wir sonst mit dem Hausbau in Frankreich von Deutschland aus erleben.
      </p>
      <div className="underline"></div>
    </Wrapper>
  )
}

export default Mission

const Wrapper = styled.article`
  text-align: center;
  margin: 2rem 0;
  h1 {
    font-size: 1.5rem;
  }
  .faint {
    margin-right: auto;
    margin-left:auto;
    color: #ccc;
    font-size: 0.8em;
    font-style: italic;
    max-width: 60%;
    text-align:center;
  }
`
